import { BookableType, type IBookableItemsFilter } from "@app/common/types";
import type { IProperty } from "@app/property/types";

import { getFullId } from "../ids/generateIds";

export const urlParamsToFilterState = (search: URLSearchParams, property: IProperty | undefined): IBookableItemsFilter => {
    if (!property) {
        return { type: undefined, filters: [] };
    }
    const queryFilterType = search.get("f[type]");
    const type =
        queryFilterType === "_" || !queryFilterType
            ? undefined
            : queryFilterType === "rp"
            ? "rp"
            : queryFilterType === "r"
            ? BookableType.Room
            : BookableType.Package;

    const filters = !!search.get("f[filters]")
        ? (search.get("f[filters]") || "").split(",").map((id) => getFullId(id, "filter", property) || id)
        : [];

    return {
        type,
        filters,
    };
};
